import React from "react";
// import { FaInstagram, FaFacebook, FaTwitter } from 'react-icons/fa'

const Footer = () => {
  return (
    <>
      <div class="main-footer">
        <div className="footer-top">
          <div className="footerlogo-img">
            <img src="./logo1-rbg.png" alt="#" />
          </div>
          <div className="footer-content">
            <p>Have any questions?</p>
            <p>
              Call Us: 0755-4255-599 ,<br></br> Mail Us:
              bhopalacademycoedschool@gmail.com
            </p>
            <p>
              <p>Visit us at:</p>
              <p>
                80 Feet Road, Naveen Nagar, Bhopal - 462010 (Near Railway Station)
              </p>

            </p>
          </div>
          <div className="socialmedia-link">
            <div className="socialall">
              <div>
                <a
                  href="https://www.facebook.com/people/Bhopal-academy-co-ed-hr-sec-school/100064205823889/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="alllink-soc">
                    <img
                      src="./hfb.png"
                      alt="Facebook"
                      datatip="FACEBOOK"
                      dataplace="bottom"
                      style={{
                        width: "42px",
                        height: "48px",
                        borderRadius: "50%",
                        objectFit: "fill",
                      }}
                    />
                  </div>
                </a>
              </div>
              <div>
                <a
                  href="https://www.facebook.com/people/Bhopal-academy-co-ed-hr-sec-school/100064205823889/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="alllink-soc">
                    <img
                      src="./hinsta.jpeg"
                      alt="Instagram"
                      datatip="INSTAGRAM"
                      dataplace="bottom"
                      style={{
                        width: "42px",
                        height: "48px",
                        borderRadius: "50%",
                        objectFit: "fill",
                      }}
                    />
                  </div>
                </a>
              </div>
              <div>
                <a
                  href="https://www.facebook.com/people/Bhopal-academy-co-ed-hr-sec-school/100064205823889/"
                  target="_blank"
                  rel="noreferrer"
                > </a>
                  {/* <div className="alllink-soc">
                    <img
                      src="./hutub.jpeg"
                      alt="YouTube"
                      datatip="YOUTUBE"
                      dataplace="bottom"
                      style={{
                        width: "42px",
                        height: "48px",
                        borderRadius: "50%",
                        objectFit: "fill",
                      }}
                    />
                  </div> */}
               
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© All Rights Reserved by, Bhopal Academy</p>
          <p className="footer-made">
            Made with <i class=" ri-heart-3-fill"></i> by{" "}
            <a href="https://maitretech.com/"> Maitretech Solution</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
